import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface Props {
  header: string;
  message: string;
  button: string;
  isOpen: boolean;
  onClose: () => void;
}

export default function AlertDialog(props: Props): JSX.Element {
  const { header, message, button, onClose, isOpen } = props;

  return (
    <React.Fragment>
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title">{header}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {button !== '' ? (
            <Button onClick={onClose} autoFocus>
              {button}
            </Button>
          ) : (
            <></>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
